import { z } from "zod";

export const SubcontaSchema = z.object({
    idSubconta: z.number().int().optional(),
    idSubcontaPai: z.number().int().optional().nullable(),
    codigo: z.string().nonempty("Código é obrigatório"),
    descricao: z.string().nonempty("Descrição é obrigatória"),
    ativo: z.coerce.boolean().default(true),

});

export type SubcontaForm = z.infer<typeof SubcontaSchema>;

export const defaultSubcontaForm: Partial<SubcontaForm> = {
    idSubcontaPai: undefined,
    codigo: undefined,
    descricao: undefined,
    ativo: true,

};
